import { question } from "@/components/icons/SVGIcons";
import { ReactNode } from "react";
import { Tooltip } from "react-tooltip";
import clsx from "clsx";

interface IInfoTooltip {
  id: string;
  message: ReactNode;
  // Override the default width for content that reads badly when wrapped
  // (e.g. a list of options). The tooltip is absolutely positioned, so a wider
  // one floats over neighbours rather than reflowing them.
  maxWidthClass?: string;
  // Extra classes for the tooltip bubble itself. react-tooltip's default is
  // dark-only (#222 bg, white text) - fine over a dark UI, but stands out as
  // an unstyled box over a light one. "!" is required to beat react-tooltip's
  // own inline background/text styles.
  tooltipClassName?: string;
}

const InfoTooltip = ({
  id,
  message,
  maxWidthClass = "max-w-[220px]",
  tooltipClassName,
}: IInfoTooltip) => {
  return (
    <>
      <span
        data-tooltip-id={id}
        className="ml-1 flex h-3.5 w-3.5 cursor-default items-center text-gray-400 dark:text-gray-500"
      >
        {question}
      </span>
      <Tooltip
        id={id}
        place="right"
        className={clsx(
          "z-50 !whitespace-normal !text-xs",
          maxWidthClass,
          tooltipClassName,
        )}
      >
        {message}
      </Tooltip>
    </>
  );
};

export default InfoTooltip;
